// extracted by mini-css-extract-plugin
export var container = "styles-module--container--I0FCq";
export var child = "styles-module--child--5OqMm";
export var background = "styles-module--background--Koy+i";